import script from "./BlockLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./BlockLoader.vue?vue&type=script&setup=true&lang=js"

import "./BlockLoader.vue?vue&type=style&index=0&id=2581671f&lang=css"

const __exports__ = script;

export default __exports__